<template lang="html">
  <modal name="confirm-modal" height="auto" width="416" :adaptive="true" :maxWidth="416" class="confirm-modal" @before-open="beforeOpen">
    <div class="modal-container">
      <div class="modal-body">
        <div :class="[bold ? 'bold' : '']" v-html="confirmMessage" />
      </div>
      <div class="line-break-gray" />
      <div class="modal-footer flex-box">
        <div class="cancel-section">
          <SymbiumButton
            kclass="btn-base dialog-btn"
            :isSmall="true"
            :text="cancelText || 'Cancel'"
            :onClick="() => cancelCallBack()"
          />
        </div>

        <SymbiumButton
          kclass="btn-base"
          :isSmall="true"
          :text="actionText"
          :onClick="confirmCallBack"
          :loading="false"
        />
      </div>
    </div>
  </modal>
</template>

<script>
import SymbiumButton from 'src/components/common/SymbiumButton.vue'

export default {
  components: { SymbiumButton },
  data() {
    return this.defaultData();
  },
  methods: {
    beforeOpen(event) {
      Object.assign(this.$data, this.defaultData())
      this.actionText = event.params.actionText
      this.cancelText = event.params.cancelText
      this.confirmMessage = event.params.confirmMessage
      this.confirmCallBack = event.params.confirmCallBack || this.confirmCallBack
      this.cancelCallBack = event.params.cancelCallBack || this.cancelCallBack
      this.alert = event.params.alert != undefined ? event.params.alert : true
      this.bold = event.params.bold != undefined ? event.params.bold : true
    },
    defaultData() {
      return {
        confirmMessage: null,
        actionText: null,
        cancelText: null,
        confirmCallBack() {},
        cancelCallBack() {
          this.$modal.hide('confirm-modal')
        },
        alert: true,
        bold: true,
      }
    }
  }
}
</script>

<style lang="scss">
.modal-body {
  min-height: auto !important;
}

.cancel-section {
  flex-grow: 1;
  text-align: left;
}
</style>
